const DEFAULT_DEBOUNCE_MS = 300

/**
 * Returns a debounced wrapper around `fn`. Each call resets the timer; only
 * the last call inside the delay window runs.
 *
 * The `never[]` generic constraint is the contravariant TypeScript idiom for
 * "any args" without introducing `any`.
 */
export function debounce<T extends (...args: never[]) => void>(fn: T, delay = DEFAULT_DEBOUNCE_MS) {
  let timer: ReturnType<typeof setTimeout>

  return (...args: Parameters<T>) => {
    clearTimeout(timer)
    timer = setTimeout(() => {
      fn(...args)
    }, delay)
  }
}
